import React from "react"
import { Button, Col, Form, ListGroup, Row } from "react-bootstrap"
import { Door, Tenant } from "../data/models.interface"

interface IForbiddenDoorsField {
	tenant: Tenant
	setTenant: (tenant: Tenant) => void
	doors?: Door[]
}

const ForbiddenDoorsField: React.FC<IForbiddenDoorsField> = ({ tenant, setTenant, doors = [] }) => {
	const selectedValues =
		tenant.UserDefinedValues.find((v) => v.Name === "Forbidden Doors")
			?.Value?.split(",")
			.filter((v) => !!v) || []

	const handleDelete = (value: string) => {
		let udf = tenant.UserDefinedValues.find((u) => u.Name === "Forbidden Doors")
		// make udf if it doesn't exist
		if (!udf) {
			// UserDefinedFieldID is ignored in the update
			udf = { Name: "Forbidden Doors", Value: "", UserDefinedFieldID: 0 }
			tenant.UserDefinedValues.push(udf)
		}
		//
		udf.Value = selectedValues.filter((v) => v !== value).join(",")
		setTenant({ ...tenant })
	}

	const handleAdd = (newValue: string) => {
		let udf = tenant.UserDefinedValues.find((u) => u.Name === "Forbidden Doors")
		// make udf if it doesn't exist
		if (!udf) {
			// UserDefinedFieldID is ignored in the update
			udf = { Name: "Forbidden Doors", Value: "", UserDefinedFieldID: 0 }
			tenant.UserDefinedValues.push(udf)
		}
		//
		selectedValues.push(newValue)
		udf.Value = selectedValues.join(",")
		setTenant({ ...tenant })
	}

	return (
		<div>
			<Form.Label>Forbidden Doors</Form.Label>
			<ListGroup>
				{selectedValues.map((value) => (
					<ListGroup.Item key={value} className="d-flex justify-content-between align-items-center">
						{getName(value, doors)}
						<Button variant="outline-danger" size="sm" onClick={() => handleDelete(value)}>
							X
						</Button>
					</ListGroup.Item>
				))}
			</ListGroup>
			<Form>
				<Row>
					<Col xs={12}>
						<Form.Select
							value=""
							onChange={(e) => handleAdd(e.target.value)}
							disabled={doors.length === 0}
							className="mb-3">
							<option value="">Select a Door to remove this Resident's access</option>
							{doors.map((door) => (
								<option key={door.id} value={door.accessControllerSerialNumber + "#" + door.doorNumber}>
									{door.fullName}
								</option>
							))}
						</Form.Select>
					</Col>
				</Row>
			</Form>
		</div>
	)
}

export default ForbiddenDoorsField

const getName = (value: string, doors: Door[]) => {
	const [serialNumber, doorNumber] = value.split("#")
	const door = doors.find(
		(d) => d.accessControllerSerialNumber === serialNumber && d.doorNumber === parseInt(doorNumber),
	)
	return door ? door.fullName : value
}
